import { FormattedMessage } from 'react-intl';
import {
  Panel,
  PanelHeader,
  PanelSubtitle,
  PanelTitle,
  PanelTitleWrapper
} from 'components/panel';
import messages from 'messages';
import { useContext, useEffect } from 'react';
import { StoreContext } from 'index';
import Loader from 'components/loader/Loader';
import RetryPanel from 'containers/partials/error-boundary/RetryPanel';
import { useParams, useRouteMatch } from 'react-router-dom';
import { ROUTE_USER_ENTITY_DOCUMENTS } from 'routes/RouteList';
import useFiles from 'hooks/queries/useFiles';
import DocumentsList from 'containers/partials/lists/DocumentsList';

function Documents() {
  const {
    authStore: {
      user,
      user: { id }
    }
  } = useContext(StoreContext);
  const { entityId } = useParams();

  const active = useRouteMatch([ROUTE_USER_ENTITY_DOCUMENTS]);

  const { files, loading, error, getFiles, sortFiles } = useFiles({
    entityId,
    linkId: id
  });

  useEffect(() => {
    getFiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Panel active={active?.isExact}>
      <PanelHeader borderBottom>
        <PanelTitleWrapper>
          <PanelTitle>
            <FormattedMessage {...messages.documents} />
          </PanelTitle>
          <PanelSubtitle>
            <FormattedMessage
              {...messages.documentsSubtitle}
              values={{
                name: user.getEntityName(entityId)
              }}
            />
          </PanelSubtitle>
        </PanelTitleWrapper>
      </PanelHeader>

      {loading && <Loader />}
      {error && <RetryPanel />}

      <DocumentsList entityId={entityId} files={files} sortFiles={sortFiles} />
    </Panel>
  );
}

export default Documents;
